import Vue from 'vue'
import VueRouter from 'vue-router'
import { AccessType } from '@mymsa/common'

import AdminAccessKeyView from '../views/AdminAccessKeyView.vue'
import AdminAusMeatCompanyView from '../views/AdminAusMeatCompanyView.vue'
import AdminAusMeatTraineeListView from '../views/AdminAusMeatTraineeListView.vue'
import AdminGraderListView from '../views/AdminGraderListView.vue'
import AdminInfoSysMemberListView from '../views/AdminInfoSysMemberListView.vue'
import AdminMemberTypeListView from '../views/AdminMemberTypeListView.vue'
import AdminPersonListView from '../views/AdminPersonListView.vue'
import AdminPersonView from '../views/AdminPersonView.vue'
import AdminProducerListView from '../views/AdminProducerListView.vue'
import AdminRegistrationPersonListView from '../views/AdminRegistrationPersonListView.vue'
import AdminRegistrationView from '../views/AdminRegistrationView.vue'
import AdminTraineesView from '../views/AdminTraineesView.vue'
import AdminTrainersView from '../views/AdminTrainersView.vue'
import AdminTrainingSessionListView from '../views/AdminTrainingSessionListView.vue'
import AdminTrainingSessionView from '../views/AdminTrainingSessionView.vue'
import AdminTrainingView from '../views/AdminTrainingView.vue'
import AdminView from '../views/AdminView.vue'
import EndUserTrainingView from '../views/EndUserTrainingView.vue'
import ForbiddenView from '../views/ForbiddenView.vue'
import MembershipView from '../views/MembershipView.vue'
import MemberPeopleView from '../views/MemberPeopleView.vue'
import MemberTraineesReportView from '../views/reports/MemberTraineesReportView.vue'
import RegisterView from '../views/RegisterView.vue'
import auth from '../auth.js'
import { getEnv } from '../utilities'

Vue.use(VueRouter)

const withProps = route => ({ ...route.query, ...route.params })

const routes = [
  {
    path: '/',
    redirect: { name: 'Register' }
  },
  {
    name: 'Menu',
    path: '/menu',
    beforeEnter: (to, from, next) => {
      window.location = new URL('/menu', getEnv('VUE_APP_OIDC_AUTHORITY')).toString()
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    props: route => ({
      state: route.query.state,
      nonce: route.query.nonce
    }),
    meta: {
      title: 'Registration'
    }
  },

  // Member self-management
  {
    path: '/membership',
    name: 'Membership',
    component: MembershipView,
    meta: {
      title: 'Membership',
      authName: auth.authName
    }
  },
  {
    path: '/people',
    name: 'MemberPeople',
    component: MemberPeopleView,
    meta: {
      title: 'People',
      authName: auth.authName
    }
  },

  // Training reports
  {
    path: '/reports/training/trainees',
    name: 'MemberTraineesReport',
    component: MemberTraineesReportView,
    props: withProps,
    meta: {
      title: 'Report - Member Trainees',
      authName: auth.authName
    }
  },

  // Training
  {
    path: '/end-user-training',
    name: 'EndUserTraining',
    component: EndUserTrainingView,
    props: withProps,
    meta: {
      title: 'End-User Training',
      authName: auth.authName
    }
  },

  // Admin
  {
    path: '/admin',
    name: 'Admin',
    redirect: {
      name: 'AdminRegistrationList'
    }
  },
  {
    path: '/admin/registrations',
    name: 'AdminRegistrationList',
    component: AdminView,
    meta: {
      title: 'Registrations',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF, AccessType.AUS_MEAT]
    }
  },
  {
    path: '/admin/registrations/:id',
    name: 'AdminRegistration',
    props: true,
    component: AdminRegistrationView,
    meta: {
      title: 'Member Edit',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF, AccessType.AUS_MEAT]
    }
  },
  {
    path: '/admin/access-keys',
    name: 'AdminAccessKeys',
    component: AdminAccessKeyView,
    meta: {
      title: 'Access Keys',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/people',
    name: 'AdminPersonList',
    component: AdminPersonListView,
    meta: {
      title: 'People',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/registration-people',
    name: 'AdminRegistrationPersonList',
    component: AdminRegistrationPersonListView,
    meta: {
      title: 'Registration People',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/people/:id',
    name: 'AdminPerson',
    component: AdminPersonView,
    props: true,
    meta: {
      title: 'Person',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/training/modules',
    name: 'AdminTraining',
    component: AdminTrainingView,
    meta: {
      title: 'Training Modules',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/training/sessions',
    name: 'AdminTrainingSessionList',
    component: AdminTrainingSessionListView,
    meta: {
      title: 'Training Sessions',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/training/sessions/:id',
    name: 'AdminTrainingSession',
    component: AdminTrainingSessionView,
    props: true,
    meta: {
      title: 'Training Session',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/training/trainees',
    name: 'AdminTrainees',
    component: AdminTraineesView,
    meta: {
      title: 'Trainees',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/training/trainers',
    name: 'AdminTrainers',
    component: AdminTrainersView,
    meta: {
      title: 'Trainers',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/producers',
    name: 'AdminProducerList',
    component: AdminProducerListView,
    meta: {
      title: 'Producers',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/member-types',
    name: 'AdminMemberTypeList',
    component: AdminMemberTypeListView,
    meta: {
      title: 'Member Types',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/infosys/members',
    name: 'AdminInfoSysMemberList',
    component: AdminInfoSysMemberListView,
    meta: {
      title: 'InfoSys Sync',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/graders',
    name: 'AdminGraderList',
    component: AdminGraderListView,
    meta: {
      title: 'Graders',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/aus-meat/companies',
    name: 'AdminAusMeatCompanyList',
    component: AdminAusMeatCompanyView,
    props: true,
    meta: {
      title: 'AUS-MEAT Company List',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  {
    path: '/admin/aus-meat/trainees',
    name: 'AdminAusMeatTraineeList',
    component: AdminAusMeatTraineeListView,
    meta: {
      title: 'AUS-MEAT Trainee List',
      authName: auth.authName,
      accessTypes: [AccessType.ADMINISTRATOR, AccessType.STAFF]
    }
  },
  // Error
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: ForbiddenView,
    meta: {
      title: 'Forbidden',
      authName: auth.authName
    }
  },
  // Default / not found
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard by access type
router.beforeEach((to, from, next) => {
  if (to.name === 'Forbidden') return next() // Prevent infinite loop
  if (!to.meta?.authName) return next() // If authentication is required, but user is not authenticated, vue-oidc-client will make them authenticate.
  if (!auth.isAuthenticated) return next() // vue-oidc-client will handle redirect via auth provider
  const accessType = (auth.userProfile.access_type ?? '').toLowerCase()
  const accessTypes = (to.meta?.accessTypes ?? []).map(s => s.toLowerCase())
  if (!accessTypes.length || accessTypes.includes(accessType)) return next()
  return next({ name: 'Forbidden' })
})

auth.useRouter(router)

export default router
